import * as React from 'react';
import { SVGProps } from 'react';

const IconFitToDefaultSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 2H2v12h4v-2H4V4h2V2zm4 0h4v12h-4v-2h2V4h-2V2z" />
  </svg>
);
export default IconFitToDefaultSizeS;
